import { Text, HStack, VStack } from '@genial/components';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import { clubsTableHead } from '../constants';

export const ListLoadingItemMobile: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const middleInfos1 = [
    { label: clubsTableHead[1].title, value: <TextSkeleton w="60%" />, w: '49%' },
  ];

  const middleInfos2 = [
    { label: clubsTableHead[4].title, value: <TextSkeleton w="60%" />, w: '40%' },
    { label: clubsTableHead[3].title, value: <TextSkeleton w="60%" />, w: '40%' },
    {
      label: '',
      value: <ButtonSkeleton />,
      w: '20%',
    },
  ];

  const infos = [middleInfos1, middleInfos2];

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <TextSkeleton w="60%" />
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space="stack.quarck" key={label}>
                {!!label && (
                  <Text color="neutral.black" variant="semibold">
                    {label}
                  </Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
